import { render, staticRenderFns } from "./rate-pricing.vue?vue&type=template&id=7a52fe5a&scoped=true&"
import script from "./rate-pricing.vue?vue&type=script&lang=js&"
export * from "./rate-pricing.vue?vue&type=script&lang=js&"
import style0 from "./rate-pricing.vue?vue&type=style&index=0&id=7a52fe5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a52fe5a",
  null
  
)

export default component.exports